module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("高校管理 / 编辑")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editschoolsubmit
    }
  }, [_vm._v("保 存")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.formedit,
      "label-position": "left",
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formedit.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formedit.schoolType),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "schoolType", $$v)
      },
      expression: "formedit.schoolType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("高中")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校是否签约"
    }
  }, [_c('el-radio-group', {
    staticClass: "is-signed-radio-group",
    model: {
      value: (_vm.formedit.isSigned),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "isSigned", $$v)
      },
      expression: "formedit.isSigned"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("正式签约")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("意向签约（学校试用）")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("\n                  未签约\n                  "), _c('span', {
    staticClass: "is-signed-tip"
  }, [_vm._v("“未签约”的学校，在运动世界APP端不会展示“校园跑”")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用一体机"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.changeEnableOnePC
    },
    model: {
      value: (_vm.formedit.enableOnePC),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "enableOnePC", $$v)
      },
      expression: "formedit.enableOnePC"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "一体机站点域名"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin-right": "12px",
      "flex": "1",
      "min-width": "300px"
    },
    model: {
      value: (_vm.formedit.websiteDomain),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "websiteDomain", $$v)
      },
      expression: "formedit.websiteDomain"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.formedit.websiteDomain
    },
    on: {
      "click": _vm.testConnection
    }
  }, [_vm._v("测试连接")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.formedit.isConn
    },
    on: {
      "click": _vm.dataSync
    }
  }, [_vm._v("基础数据同步")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary",
      "disabled": !_vm.formedit.isConn
    },
    on: {
      "click": _vm.syncAppPhotos
    }
  }, [_vm._v("\n                  同步APP已录入未建模的照片\n               ")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宣传图(非必填)"
    }
  }, [_c('div', {
    staticClass: "up-box"
  }, [_c('el-upload', {
    ref: "uploadRef",
    staticClass: "upload-bezel",
    class: {
      isUpload: !!_vm.formedit.posterUrl
    },
    attrs: {
      "accept": ".jpg,.png,.gif",
      "list-type": "picture-card",
      "name": "file",
      "disabled": !_vm.formedit.websiteDomain,
      "action": _vm.actionUrl,
      "headers": {
        channelCode: _vm.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj'
      },
      "data": {
        schoolId: _vm.formedit.rootUnid
      },
      "on-remove": _vm.onRemove,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "file-list": _vm.formedit.posterUrl ? [{
        url: _vm.uploadedImgUrl
      }] : []
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "bezel-tips"
  }, [_vm._v("1000*550，格式为jpg、png、gif")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生自主录入人脸"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formedit.enableStudentInputFace),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "enableStudentInputFace", $$v)
      },
      expression: "formedit.enableStudentInputFace"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "允许教师管理人脸"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formedit.enableTeacherInputFace),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "enableTeacherInputFace", $$v)
      },
      expression: "formedit.enableTeacherInputFace"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开启跑步前后人脸验证"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.changeRunFaceCheckConfig
    },
    model: {
      value: (_vm.formedit.runFaceCheckConfig.beforeAfterEnable),
      callback: function($$v) {
        _vm.$set(_vm.formedit.runFaceCheckConfig, "beforeAfterEnable", $$v)
      },
      expression: "formedit.runFaceCheckConfig.beforeAfterEnable"
    }
  })], 1), _vm._v(" "), (_vm.formedit.runFaceCheckConfig.beforeAfterEnable) ? _c('el-form-item', {
    attrs: {
      "label": "人脸验证有效时长"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "请输入",
      "controls": false,
      "max": 300,
      "min": 0
    },
    model: {
      value: (_vm.formedit.runFaceCheckConfig.checkValidTime),
      callback: function($$v) {
        _vm.$set(_vm.formedit.runFaceCheckConfig, "checkValidTime", $$v)
      },
      expression: "formedit.runFaceCheckConfig.checkValidTime"
    }
  }), _vm._v(" "), _c('span', [_vm._v("s")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开启跑步中人脸验证"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.changeRunFaceCheckConfig
    },
    model: {
      value: (_vm.formedit.runFaceCheckConfig.middleEnable),
      callback: function($$v) {
        _vm.$set(_vm.formedit.runFaceCheckConfig, "middleEnable", $$v)
      },
      expression: "formedit.runFaceCheckConfig.middleEnable"
    }
  })], 1), _vm._v(" "), (_vm.formedit.runFaceCheckConfig.middleEnable) ? _c('el-form-item', {
    attrs: {
      "label": "人脸验证有效时长"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "请输入",
      "controls": false,
      "max": 300,
      "min": 0
    },
    model: {
      value: (_vm.formedit.runFaceCheckConfig.checkRunValidTime),
      callback: function($$v) {
        _vm.$set(_vm.formedit.runFaceCheckConfig, "checkRunValidTime", $$v)
      },
      expression: "formedit.runFaceCheckConfig.checkRunValidTime"
    }
  }), _vm._v(" "), _c('span', [_vm._v("s")])], 1) : _vm._e(), _vm._v(" "), (_vm.formedit.runFaceCheckConfig.middleEnable) ? _c('el-form-item', {
    attrs: {
      "label": "跑步过程中验证点"
    }
  }, [_c('div', [_c('div', [_c('span', [_vm._v("男生：以")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入",
      "controls": false,
      "max": 9999,
      "min": 500
    },
    model: {
      value: (_vm.formedit.boyGenderConfig.checkLength),
      callback: function($$v) {
        _vm.$set(_vm.formedit.boyGenderConfig, "checkLength", $$v)
      },
      expression: "formedit.boyGenderConfig.checkLength"
    }
  }), _vm._v(" "), _c('span', [_vm._v("米为基准，在基准完成的 ")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入",
      "controls": false,
      "max": 99,
      "min": 0
    },
    model: {
      value: (_vm.formedit.boyGenderConfig.checkPointMin),
      callback: function($$v) {
        _vm.$set(_vm.formedit.boyGenderConfig, "checkPointMin", $$v)
      },
      expression: "formedit.boyGenderConfig.checkPointMin"
    }
  }), _vm._v(" "), _c('span', [_vm._v("%(含) ——")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入",
      "controls": false,
      "max": 99,
      "min": 0
    },
    model: {
      value: (_vm.formedit.boyGenderConfig.checkPointMax),
      callback: function($$v) {
        _vm.$set(_vm.formedit.boyGenderConfig, "checkPointMax", $$v)
      },
      expression: "formedit.boyGenderConfig.checkPointMax"
    }
  }), _vm._v(" "), _c('span', [_vm._v("%(含)中随机验证")])], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-top-10"
  }, [_c('span', [_vm._v("女生：以")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入",
      "controls": false,
      "max": 9999,
      "min": 500
    },
    model: {
      value: (_vm.formedit.girlGenderConfig.checkLength),
      callback: function($$v) {
        _vm.$set(_vm.formedit.girlGenderConfig, "checkLength", $$v)
      },
      expression: "formedit.girlGenderConfig.checkLength"
    }
  }), _vm._v(" "), _c('span', [_vm._v("米为基准，在基准完成的 ")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入",
      "controls": false,
      "max": 99,
      "min": 0
    },
    model: {
      value: (_vm.formedit.girlGenderConfig.checkPointMin),
      callback: function($$v) {
        _vm.$set(_vm.formedit.girlGenderConfig, "checkPointMin", $$v)
      },
      expression: "formedit.girlGenderConfig.checkPointMin"
    }
  }), _vm._v(" "), _c('span', [_vm._v("%(含) ——")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入",
      "controls": false,
      "max": 99,
      "min": 0
    },
    model: {
      value: (_vm.formedit.girlGenderConfig.checkPointMax),
      callback: function($$v) {
        _vm.$set(_vm.formedit.girlGenderConfig, "checkPointMax", $$v)
      },
      expression: "formedit.girlGenderConfig.checkPointMax"
    }
  }), _vm._v(" "), _c('span', [_vm._v("%(含)中随机验证")])], 1)])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启支付宝人脸验证"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formedit.runFaceCheckConfig.enableAlipayFaceVerification),
      callback: function($$v) {
        _vm.$set(_vm.formedit.runFaceCheckConfig, "enableAlipayFaceVerification", $$v)
      },
      expression: "formedit.runFaceCheckConfig.enableAlipayFaceVerification"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用体检一体机"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formedit.enablePhysicalPC),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "enablePhysicalPC", $$v)
      },
      expression: "formedit.enablePhysicalPC"
    }
  })], 1), _vm._v(" "), (_vm.formedit.enablePhysicalPC) ? _c('el-form-item', {
    attrs: {
      "label": "体检一体机项目选择"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.formedit.physicalExaminationSportInfo),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "physicalExaminationSportInfo", $$v)
      },
      expression: "formedit.physicalExaminationSportInfo"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "height,weight"
    }
  }, [_vm._v("身高、体重")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "vitalCapacity"
    }
  }, [_vm._v("肺活量")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用硬件防作弊"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formedit.hardwareCollection),
      callback: function($$v) {
        _vm.$set(_vm.formedit, "hardwareCollection", $$v)
      },
      expression: "formedit.hardwareCollection"
    }
  }), _vm._v(" "), _c('HardwareConfig', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.hardwareCollection),
      expression: "formedit.hardwareCollection"
    }],
    attrs: {
      "schoolId": _vm.formedit.rootUnid + '',
      "stadiumConfig": _vm.formedit.sportTimeConfigModel
    },
    on: {
      "click-record": _vm.clickUploadConfigRecord
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("是否启用")]), _vm._v(" "), _c('div', [_vm._v("场馆运动时长监控")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formedit.sportTimeConfigModel.openVenueSport),
      callback: function($$v) {
        _vm.$set(_vm.formedit.sportTimeConfigModel, "openVenueSport", $$v)
      },
      expression: "formedit.sportTimeConfigModel.openVenueSport"
    }
  }), _vm._v(" "), _c('StadiumMonitor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formedit.sportTimeConfigModel.openVenueSport),
      expression: "formedit.sportTimeConfigModel.openVenueSport"
    }],
    attrs: {
      "schoolId": _vm.formedit.rootUnid + '',
      "configModel": _vm.formedit.sportTimeConfigModel
    },
    on: {
      "update:configModel": function($event) {
        return _vm.$set(_vm.formedit, "sportTimeConfigModel", $event)
      },
      "update:config-model": function($event) {
        return _vm.$set(_vm.formedit, "sportTimeConfigModel", $event)
      },
      "click-record": _vm.clickUploadConfigRecord
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('HardwareRecord', {
    attrs: {
      "schoolId": _vm.formedit.rootUnid + '',
      "uid": _vm.uploadRecord.uid,
      "visible": _vm.uploadRecord.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.uploadRecord, "visible", $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31879790!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/UniversityManage/CollegeManage/CollegeManageDetail.vue
// module id = 981
// module chunks = 0